import { bindEvents } from '../../utils/window';

/**
 * @module directives/form/float-label
 */

/**
 * Applies the correct class names to the field.
 * @param {Event} [event=null] - The event object.
 * @param {HTMLElement} [element=null] - The element context.
 */
function setState(event = null, element = null) {
  const field = element ? element : event.currentTarget;

  /** Wrap within an instantaneous timeout so state changes can be detected on the next redraw. This fixes a
   * problem with the "keydown" event in that the key value is added to the field after the event has been
   * called. This means the value of the field returned will be the previous value. The timeout ensures that
   * the input happens before the value is checked. */
  setTimeout(_ => {

    // Enhance the file input by outputting information about the selected file
    if (field.matches('input[type="file"]')) {
      const parent = field.parentNode;
      const div = [...parent.children].filter(child => child.matches('div'))[0];

      if (div) {
        let fileName = '';
        if (field.files && field.files.length > 1) {
          fileName = `${field.files.length} files selected`;
        } else {
          fileName = field.value.split('\\').pop();
        }

        div.innerHTML = fileName;
      }
    }

    // Class toggles.
    const label = field.closest('[data-sw-float-label]')

    // Set the field type as a class to the float label wrapper
    if (!field.matches('input[type="file"]')) {
      label.classList.add('-type-' + field.tagName.toLowerCase());
    }

    // Is the element in focus?
    label.classList.toggle('is-focused',
      event ? (event.type == 'focus') || field.matches(':focus') : false);

    /**
     * Check if the fields value is an empty string. This works for select options that have an empty
     * value. This can be exploited by creating an empty option, disabling it and setting it as the
     * default. */
    label.classList.toggle('is-filled', field.value.trim().length > 0);

    // Only apply if browser supports field validation
    label.classList.toggle('is-invalid', field.validity && !field.validity.valid)

    /** Specifically for textarea's. This is useful so that the label can be hidden when the content is
     * scrolled, so that the label and the fields text don't overlap and look ugly. */
    label.classList.toggle('is-scrolled', field.scrollTop > 0);
  });
}

/**
 * Adds float label behaviour to marked fields.
 */
export default function floatLabelDirective() {

  // Bind events to form inputs.
  document.querySelectorAll('[data-sw-float-label]').forEach(element => {
    element.querySelectorAll('input, select, textarea').forEach(input => {
      bindEvents(input, "focus blur change keyup keydown scroll", setState);
      setState({}, input);
    });
  });
}



// WEBPACK FOOTER //
// ./source/scripts/directives/form/float-label.js